import React, { useRef, useState, useId } from "react";
import './PortalUsersSigUp.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import emailjs from 'emailjs-com';
import { v4 as uuidv4 } from 'uuid';
import validator from 'validator';

export default function PortalUsersSigUp({ setUpdateApp, showsetNotification, showsetNotificationType }) {
    // Helpers
    const [Rendder, setRendder] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    // Project Info
    const [FirstName, setFirstName] = useState(false);
    const [LastName, setLastName] = useState(false);
    const [UserID, setUserID] = useState(uuidv4());
    const [PhoneNumber, setPhoneNumber] = useState(false);
    const [Email, setEmail] = useState(false);
    const [IsEmailExist, setIsEmailExist] = useState([]);
    const [IsEmailExistBoolen, setIsEmailExistBoolen] = useState(false);
    const [LoadingEmail, setLoadingEmail] = useState(false);
    const [LoadingEmail2, setLoadingEmail2] = useState(false);
    const [EmailCode, setEmailCode] = useState(false);
    const [LoadingProject, setLoadingProject] = useState(false);
    const [LoadingMatchingIndex, setLoadingMatchingIndex] = useState(0);
    const [StorageCodeLocal, setStorageCode] = useState(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000);

    const timestampInMs = Date.now();
    const [UserInfo, setUserInfo] = useState({
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        Email: '',
        Code: '',
        PassWord: '',
        UserDateCreated: timestampInMs,
        LastLoginUserDate: timestampInMs,
        UserIP: "",
        UserAgent: navigator.userAgent,
        UserProfilePicture: null,
        FirstProject: true,
    });


    // intervalFun()
    const containerRef2 = useRef(null);
    const scrollRight = (pages, leftOrReight) => {
        setRendder(a => !a)
        const container = containerRef2.current;
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount;
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount;
        }
        setRendder(a => !a)

    };

    // Loading Function to my projects
    var timesRun = 0;
    const intervalFun2 = (seconds) => {
        setLoadingProject(true)
        var interval = setInterval(function () {
            timesRun += 1;
            setLoadingMatchingIndex(timesRun)
            if (timesRun === seconds) {
                setRendder(a => !a)
                setUpdateApp(a => !a)
                // localStorage.setItem("Project", JSON.stringify(ProjectList))
                scrollRight(8, true)
                clearInterval(interval);
                setLoadingProject(false)
                window.scrollTo(0, 0)
            }
        }, 1000);
    }

    // Send From Titan SMTP Email JS HnadyBy.com and check if usser exist
    function sendEmail(e) {
        window.scrollTo(0, 0)
        e.preventDefault();
        (async () => {
            if (UserInfo.Email && UserInfo.Email.length && validator.isEmail(UserInfo.Email)) {
                setLoadingEmail(true)
                window.scrollTo(0, 0)
                setRendder(a => !a)
                const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/handyby-users?q={"UserEmail":"${UserInfo.Email.toLocaleLowerCase()}"}&h={"$fields": {"UserEmail": 1, "status": 1} }`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'apikey': '6714a668e2b4472fa2c2d036'
                    }
                });
                const data1 = await res1.json()
                setLoadingEmail(false)
                setRendder(a => !a)
                showsetNotificationType('emailsent')
                showsetNotification(true)

                if (data1.length) {
                    setIsEmailExistBoolen(true)
                    setRendder(a => !a)

                } else {
                    // handleClickFocusOnInputConfirmedCode()
                    setStorageCode(StorageCodeLocal)
                    scrollRight(1, true)
                    window.scrollTo(0, 0)
                    setEmail(false)
                    setRendder(a => !a)

                    emailjs.sendForm('service_bps6foc', 'template_4h1sufs', e.target, 'QeqW-bXHRNjRmhZ6I')
                        .then((result) => {
                            handleClickFocusOnInputConfirmedCode();
                        }, (error) => {
                            console.log("error", error.text);
                        });
                }
            } else {
                setEmail(true)
                setRendder(a => !a)

            }
        })()

    }
    // Create User
    function CreateUser() {
        (async () => {
            setLoadingEmail2(true)
            const res1 = await fetch('https://bhocs-10ec.restdb.io/rest/handyby-users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': '6714a668e2b4472fa2c2d036'
                },
                body: JSON.stringify({
                    FirstName: UserInfo.FirstName,
                    LastName: UserInfo.LastName,
                    PhoneNumber: UserInfo.PhoneNumber,
                    UserEmail: UserInfo.Email,
                    PassWord: '',
                    UserDateCreated: UserInfo.UserDateCreated,
                    LastLoginUserDate: UserInfo.LastLoginUserDate,
                    UserIP: UserInfo.UserIP,
                    UserID: UserID,
                    UserAgent: UserInfo.UserAgent,
                    UserProfilePicture: null,
                    FirstProject: true,
                })
            });
            const data1 = await res1.json()
            if (data1) {
                localStorage.setItem("UserSessionn", JSON.stringify({
                    // FirstName: UserInfo.FirstName,
                    // LastName: UserInfo.LastName,
                    // PhoneNumber: UserInfo.PhoneNumber,
                    // UserEmail: UserInfo.Email,
                    // UserDateCreated: UserInfo.UserDateCreated,
                    // LastLoginUserDate: UserInfo.LastLoginUserDate,
                    // UserIP: UserInfo.UserIP,
                    UserID: UserID,
                    // UserAgent: UserInfo.UserAgent,
                    // UserProfilePicture: null,
                    // FirstProject: true,
                }))

                setUpdateApp(a => !a)
                showsetNotificationType('signup')
                setLoadingEmail2(false)
                navigate('/account/dashboard')
                showsetNotification(true)
            }
        })()

    }

    const inputRef = useRef(null);
    const handleClickFocusOnInputConfirmedCode = () => {
        inputRef.current.focus();
    };
    // useEffect
    useEffect(() => {

        (async () => {
            scrollRight(0, false)
            const response = await fetch('https://geolocation-db.com/json/');
            const data = await response.json();
            UserInfo.UserIP = data


        })()
    }, [null]);

    return (
        <div className="PortalUsersSigUp">
            {/* <button onClick={() => {

                showsetNotification(true)
                showsetNotificationType("signup")

            }}>aaaa</button> */}
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>Reifly - Find The Best Jet PortalUsersSigUp</title>
                {/* <!-- META --> */}
                <meta property="og:locale" content="en_US" data-react-helmet="true" />
                <meta property="og:type" content="article" data-react-helmet="true" />
                <meta property="og:image" content="article" data-react-helmet="true" />
                <meta property="og:url" content="https://www.mcaandco.com/" data-react-helmet="true" />
                <meta name="description" content="Our cash advance offers swift access to tailored funding solutions, empowering your business's growth and financial success. Explore opportunities today!" data-react-helmet="true" />
                <meta property="og:title" content="MCA & Co, Merchant Cash Advance" data-react-helmet="true" />
                <meta property="og:description" content="Our cash advance offers swift access to tailored funding solutions, empowering your business's growth and financial success. Explore opportunities today!" data-react-helmet="true" />
                <meta property="og:site_name" content="MCA & Co, Merchant Cash Advance" data-react-helmet="true" />
                <meta name="keywords" content="Financing, Business, Advance, Funding, Cash, Merchant, Capital, Loan, Credit, Repayment" data-react-helmet="true"></meta>
            </Helmet>

            <div className="PortalUsersSigUpHeader">
                <a href="/">HandyBy</a>
                <span>
                    <h2>Are you a service professional?</h2>
                    <a href="/pro-sign-up">Sign in now.</a>
                </span>
            </div>
            <div className="PortalUsersSigUpMain" ref={containerRef2}>


                {/* Email */}
                <div className="PortalUsersSigUpMainPageEmail">
                    <h1>Let's verify your email address.</h1>
                    <div className="PortalUsersSigUpMainBox">
                        <div className="PortalUsersSigUpMainBoxTextInput">
                            <h5>Email</h5>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                style={Email ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}
                                // defaultValue={UserInfo.Email}
                                // Value={UserInfo.Email}
                                autoFocus
                                onChange={(e) => {
                                    UserInfo.Email = e.target.value.toLocaleLowerCase()
                                    setEmail(false)
                                    setRendder(a => !a)
                                }}
                            />
                        </div>
                        {Email ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>Please enter a valid Email</h6> : null}
                        {IsEmailExistBoolen ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>If you already have an account with this email, <a href="/login">please log in instead.</a></h6> : null}
                        <div className="PortalUsersSigUpMainBoxButtons">
                            <button className="PortalUsersSigUpMainBoxButtonsPrevius" onClick={() => {
                                if (UserInfo.ZipCode) {
                                    navigate('/')
                                } else {
                                    navigate('/')
                                }
                            }}>Back</button>

                            <form className="PortalUsersSigUpMainBoxButtonsNext" onClick={() => window.scrollTo(0, 0)} onSubmit={sendEmail}>
                                <input type="hidden" name="email" defaultValue={UserInfo.Email} />
                                <input type="hidden" name="passcode" defaultValue={StorageCodeLocal} />
                                {LoadingEmail ?
                                    <div className="BookMainBoxButtonsLoading">
                                        <img src={require(`../../Images/loading.png`)} alt="Chimney Cleaning" />
                                    </div>
                                    :
                                    <input type="submit" value="Submit" />
                                }
                            </form>
                        </div>
                        <h2 >Already have an accounnt? <a href="/login"> Click to Log In</a></h2>

                    </div>
                    {url.searchParams.get('discount') == "yes" ?
                        <div className="UserFirstProjectApply">
                            <img src={require(`../../Images/business.png`)} />
                            <span>
                                <h1>Welcome! $10 Off Applied</h1>
                                <p>Sign up today and get matched with a trusted pro. Discount is applied after your first project is submitted.</p>
                            </span>
                        </div>
                        : null}
                </div>
                {/* Email > Confirmed Coded */}
                <div className="PortalUsersSigUpMainPageConfirmedEmail">
                    <h1>Check your email to continue.</h1>
                    <div className="PortalUsersSigUpMainBox">
                        <h2>Please enter the 6-digit code we sent to {UserInfo.Email}.</h2>
                        <div className="PortalUsersSigUpMainBoxTextInput">
                            <h5>Code</h5>
                            <input
                                type="number"
                                inputMode="numeric"
                                // inputMode="decimal"
                                value={UserInfo.Code}
                                maxLength={6}
                                ref={inputRef}
                                pattern="^[0-9\b]+$"
                                style={{ "caretColor": "transparent" }}
                                onChange={(e) => {
                                    if (e.target.value.length == 6) {
                                        UserInfo.Code = e.target.value
                                        setEmailCode(true)
                                        setRendder(a => !a)
                                    }
                                    else {
                                        UserInfo.Code = e.target.value
                                        setRendder(a => !a)
                                    }
                                }}
                            />
                            <div className="PortalUsersSigUpMainBoxTextInputBoxesList">
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 0 ? { "border": "2px solid red" } : null}>
                                    <h1 >{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(0) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 0 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 1 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(1) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 1 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 2 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(2) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 2 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 3 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(3) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 3 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 4 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(4) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 4 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersSigUpMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 5 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(5) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 5 || UserInfo.Code.length == 6 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersSigUpMainBoxTextInputBoxLoadinig"></div>
                                </div>
                            </div>
                        </div>
                        {EmailCode && UserInfo.Code !== JSON.stringify(StorageCodeLocal) ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>Invalid Code</h6> : null}
                        <div className="PortalUsersSigUpMainBoxButtons">
                            <button className="PortalUsersSigUpMainBoxButtonsNext" onClick={() => {
                                // handleClickFocusOnInputConfirmedCode()
                                if (UserInfo.Code && UserInfo.Code.length && UserInfo.Code == StorageCodeLocal) {
                                    setEmailCode(true)
                                    window.scrollTo(0, 0)
                                    scrollRight(2, true)
                                } else {
                                    setEmailCode(true)
                                    setRendder(a => !a)
                                }

                            }}>Verify and continue</button>
                        </div>
                    </div>
                    <h4>Don't see the email? Check your junk folder, If you still <br /> can't see pleaes start over</h4>
                    <a href="/sign-up">Start over</a>

                </div>
                {/* Full Name, Phone and Password */}
                <div className="PortalUsersSigUpMain_UserDetails">
                    <h1>Let's verify your email address.</h1>
                    <div className="BookMainBox">
                        <h2>Tell us about you</h2>
                        {/* First and Last Name */}
                        <div className="BookMainBoxList2">
                            <div className="BookMainBoxBox">
                                <h5>First Name</h5>
                                <div className="BookMainBoxTextInput" style={FirstName ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                    <input type="text" name="" id=""
                                        defaultValue={UserInfo.FirstName}
                                        onChange={(e) => {
                                            UserInfo.FirstName = e.target.value
                                            setRendder(a => !a)
                                        }}
                                    />
                                </div>
                                {FirstName ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid First Name</h6> : null}

                            </div>
                            <div className="BookMainBoxBox" >
                                <h5>Last Name</h5>
                                <div className="BookMainBoxTextInput" style={LastName ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                    <input type="text" name="" id=""
                                        defaultValue={UserInfo.LastName}
                                        onChange={(e) => {
                                            UserInfo.LastName = e.target.value
                                            setRendder(a => !a)
                                        }}
                                    />
                                </div>
                                {LastName ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Last Name</h6> : null}

                            </div>
                        </div>
                        {/* Phone */}
                        <div className="BookMainBoxBox">
                            <h5>Phone</h5>
                            <div className="BookMainBoxTextInput" style={PhoneNumber ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                <input type="tel" name="" id=""
                                    defaultValue={UserInfo.PhoneNumber}
                                    onChange={(e) => {
                                        UserInfo.PhoneNumber = e.target.value
                                        setRendder(a => !a)
                                    }}
                                />
                            </div>
                            {PhoneNumber ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Phone Number</h6> : null}

                        </div>

                        <div className="BookMainBoxButtons">
                            {!LoadingEmail2 ?
                                <button className="BookMainBoxButtonsNext" onClick={() => {
                                    if (!UserInfo.FirstName) { setFirstName(true) } else { setFirstName(false) }
                                    if (!UserInfo.LastName) { setLastName(true) } else { setLastName(false) }
                                    if (UserInfo.PhoneNumber && validator.isMobilePhone(UserInfo.PhoneNumber)) { setPhoneNumber(false) } else { setPhoneNumber(true) }

                                    if (UserInfo.FirstName && UserInfo.LastName && UserInfo.PhoneNumber && validator.isMobilePhone(UserInfo.PhoneNumber)) {
                                        CreateUser()
                                    } else {
                                        return null
                                    }
                                }}>Sign me up!</button>
                                :
                                <div className="BookMainBoxButtonsLoading">
                                    <img src={require(`../../Images/loading.png`)} />
                                </div>
                            }
                        </div>
                        <h6>By clicking Request Service Pros, I agree to HandyBy's Terms and Privacy Policy, and that HandyBy and its service professionals, or parties acting on their behalf, may use automated technology and prerecorded messages to deliver marketing calls or texts regarding my project and future projects to the number I provided. Consent is not a condition of service.</h6>
                    </div>
                </div>
            </div>

        </div >
    )
}

